import React, { useState, useEffect } from "react";
import { T } from "./theme";
import { SectionHeader, Card, Note } from "./ui";
import { Icon } from "./Icons";
import { REGULAMENTO as REGULAMENTO_DEFAULT } from "./regulamentoData";
import { supabase, isSupabaseReady } from "./supabase";

// ═══════════════════════════════════════════════════════════════════════
// REGULAMENTO — accordion. Lê do Supabase (chave='regulamento') com fallback hardcoded
// ═══════════════════════════════════════════════════════════════════════

export default function Regulamento({ currentUser } = {}) {
  const [aberta, setAberta] = useState(0);
  const [REGULAMENTO, setRegulamento] = useState(REGULAMENTO_DEFAULT);
  const isProprietario = currentUser?.role === "proprietario";

  useEffect(() => {
    if (!isSupabaseReady) return;
    (async () => {
      const { data } = await supabase.from("configuracoes").select("valor").eq("chave", "regulamento").maybeSingle();
      if (data?.valor) {
        try {
          const v = typeof data.valor === "string" ? JSON.parse(data.valor) : data.valor;
          if (v && v.secoes && v.secoes.length) setRegulamento(v);
        } catch {}
      }
    })();
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <SectionHeader
        title="Regulamento Oficial"
        subtitle={`Programa Bellanor Alta Performance · Versão ${REGULAMENTO.versao} · Vigência desde ${new Date(REGULAMENTO.vigenciaDesde).toLocaleDateString("pt-BR")}`}
        icon={<Icon.book size={24} />}
      />

      {isProprietario && (
        <Note tone="warn" icon={<Icon.alert size={14} />}>
          <b>Aviso importante (só você vê):</b> Este regulamento é a minuta técnica do Programa. O documento oficial publicado deve ser revisado por advogado da Bellanor antes de produzir efeitos legais plenos. Disposições sobre tributação, franquia (Lei 13.966/2019) e LGPD (Lei 13.709/2018) podem requerer adaptação ao caso concreto.
        </Note>
      )}

      <Card soft>
        <div style={{ fontSize: 12, color: T.textSub, lineHeight: 1.7 }}>
          Ao utilizar a plataforma <b>app.bellanor.com.br</b>, o corretor reconhece ter <b>lido, compreendido e aceitado</b> integralmente os termos deste regulamento. O aceite é registrado no primeiro login, com IP, data e hora, conforme Seção 2.
        </div>
      </Card>

      {/* Accordion */}
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {REGULAMENTO.secoes.map((s, idx) => (
          <div key={idx} style={{
            background: T.card, border: `1px solid ${T.border}`,
            borderRadius: T.r.lg, overflow: "hidden",
          }}>
            <button
              onClick={() => setAberta(aberta === idx ? -1 : idx)}
              style={{
                width: "100%", background: aberta === idx ? T.brandSoft : "transparent",
                border: "none", padding: "16px 20px", cursor: "pointer",
                display: "flex", justifyContent: "space-between", alignItems: "center",
                textAlign: "left", fontFamily: "inherit",
                transition: `background 160ms ${T.ease}`,
              }}
            >
              <span className="serif" style={{
                fontSize: 17, fontWeight: 600,
                color: aberta === idx ? T.brand : T.text,
                letterSpacing: -0.2,
              }}>
                {s.titulo}
              </span>
              <span style={{
                color: T.brand, fontSize: 18, fontWeight: 600,
                transform: aberta === idx ? "rotate(180deg)" : "rotate(0)",
                transition: `transform 220ms ${T.ease}`,
                display: "flex",
              }}>
                <Icon.arrowUp size={16} />
              </span>
            </button>

            {aberta === idx && (
              <div style={{ padding: "4px 20px 20px" }}>
                {s.conteudo.map((p, i) => (
                  <p key={i} style={{
                    fontSize: 13, color: T.textSec,
                    lineHeight: 1.75, margin: i > 0 ? "10px 0 0" : 0,
                    textAlign: "justify",
                  }}>
                    {p}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Rodapé */}
      <Card soft>
        <div style={{ textAlign: "center", fontSize: 11, color: T.textSub, lineHeight: 1.7 }}>
          <div style={{ marginBottom: 6 }}>
            <b>Bellanor Móveis · Programa Alta Performance</b>
          </div>
          <div>Foro: Comarca de Fortaleza/CE · Ciclo anual: 1º jan — 31 dez</div>
          <div style={{ marginTop: 8, color: T.textDim, fontStyle: "italic" }}>
            Em caso de dúvidas, entre em contato através do módulo de Suporte.
          </div>
        </div>
      </Card>
    </div>
  );
}
